import React, { Component } from 'react';
import { Container, Row, Col, Form } from "react-bootstrap";
import { Button } from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import Select from '../../Components/PCSelect';
import WeekRangeSelect from '../../Components/WeekRangeSelect';
import { money, getWeekDetails } from '../../helper';
import Detail from './Detail';
import PageHeader from '../../Pages/admin/shared/PageHeader';
import PrintButton from '../../Pages/admin/shared/PrintButton';
import FilterCard from '../../Pages/admin/shared/FilterCard';

class WarehouseBalance extends Component {
    constructor(props) {
        super(props);
        this.state = {
            WarehouseList: [],
            WeeklyWarehouse: "",
            // Default the filter to the current week so the dropdown opens on it
            // instead of the oldest listed week. The report still waits for "View".
            From_Week: getWeekDetails().weekId,
            To_Week: getWeekDetails().weekId,
            showReport: false,
            ReportDetails: {}
        }
    }

    componentDidMount() {
        this.getWarehouse()
    }

    async getWarehouse() {
        const getWarehouse = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetAllWarehouse.php`);
        let warehouseData = getWarehouse.data
        let WarehouseList = []
        if (warehouseData.success === 1) {
            for (let i = 0; i < warehouseData.data.length; i++) {
                const warehouse = warehouseData.data[i];
                WarehouseList.push({
                    value: warehouse.WAREHOUSE_ID,
                    label: warehouse.WAREHOUSE_NAME
                })
            }
        }
        this.setState({ WarehouseList })
    }

    handleChange(fieldName, evnt) {
        let targetValue = ""
        switch (fieldName) {
            case 'WeeklyWarehouse':
                targetValue = evnt
                break;
            default:
                targetValue = evnt.target.value
                break;
        }

        this.setState({ [fieldName]: targetValue })
    }

    async viewReport() {
        if (!this.state.WeeklyWarehouse || this.state.From_Week === "" || this.state.To_Week === "") {
            Swal.fire('Error', 'Please select Warehouse and From / To week', 'error')
            return
        }

        this.props.toggleLoader(true)
        try {
            const formData = {
                WH_ID: this.state.WeeklyWarehouse.value,
                From_Week: this.state.From_Week,
                To_Week: this.state.To_Week
            }
            const res = await axios.post(`${process.env.REACT_APP_BASE_URL}services/report/warehouseBalance.php`, formData);
            const resp = res.data
            if (resp.success === 1) {
                this.setState({ ReportDetails: resp.data, showReport: true })
            } else {
                this.setState({ showReport: false, ReportDetails: {} })
                Swal.fire('No Data', resp.message || 'No record found!', 'info')
            }
        } catch (error) {
            console.error('warehouseBalance error :>> ', error);
            Swal.fire('Error', 'Could not load the report.', 'error')
        }
        this.props.toggleLoader(false)
    }

    render() {
        return (
            <Container>
                <PageHeader breadcrumb="section" title="Warehouse Balance"
                    right={<PrintButton content={() => this.newRef} disabled={this.state.showReport !== true} />} />
                <FilterCard>
                    <Row style={{ alignItems: 'center' }} >
                        <Col md={3}>
                            <Form.Group className="mb-3" >
                                <Form.Label>Warehouse</Form.Label>
                                <Select menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    style={{ height: '32px' }}
                                    value={this.state.WeeklyWarehouse}
                                    options={this.state.WarehouseList}
                                    onChange={this.handleChange.bind(this, "WeeklyWarehouse")}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-3" >
                                <Form.Label><span>From Week</span></Form.Label>
                                <WeekRangeSelect
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    value={this.state.From_Week}
                                    onChange={this.handleChange.bind(this, "From_Week")}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-3" >
                                <Form.Label><span>To Week</span></Form.Label>
                                <WeekRangeSelect
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    value={this.state.To_Week}
                                    onChange={this.handleChange.bind(this, "To_Week")}
                                />
                            </Form.Group>
                        </Col>
                        <Col style={{ alignSelf: "center" }} >
                            <Button onClick={this.viewReport.bind(this)} variant="contained" size='small' >View</Button>
                        </Col>
                    </Row>
                </FilterCard>

                {this.state.showReport === true ?
                    <Detail ref={el => (this.newRef = el)} ReportDetails={this.state.ReportDetails} money={money} />
                    :
                    ""
                }
            </Container >
        );
    }
}

export default WarehouseBalance;
